angular.module("groups")

    .controller("EndPositionAndAddNewPositionModalCtrl", ['endPosition', 'treeService', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', '$rootScope', 'logService',
        function (endPosition,  treeService, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, $rootScope, logService) {

        $scope.showError = false;
        $scope.allowWrite = true;

        $scope.persons = {
            to_date: (endPosition == true ? new Date() : null),
            from_date: new Date(),
            position_treatment_id: null,
            person_treatment_id: null
        };
        $scope.endPosition = endPosition;

        let loadGroups = function (reload) {
            if (angular.isDefined($scope.personGroups) && !reload) return;
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/Groups/GetGroupsPositions'
            }).then(function (results, status, headers, config) {
                var data = treeService.groups(results.data.rows, null);
                $scope.personGroups = data;
            });
        };

        loadGroups(false);

        let loadPersonsTreatments = function (reload) {
            if (angular.isDefined($scope.personTreatments) && !reload) return;
            Restangular.all('PersonsTreatments').getList().then(function (treatments) {
                $scope.personTreatments = treatments;
                $scope.persons.person_treatment_id = treatments.filter(function (item) {
                    return item.person_default === true;
                })[0].id;
                $scope.persons.position_treatment_id = treatments.filter(function (item) {
                    return item.position_default === true;
                })[0].id;

            });
        };
        loadPersonsTreatments(false);

        //cargamos cargos en grupo
        $scope.getPositions = function (group_id) {
            var positions = [];
            if (angular.isDefined($scope.personGroups)) {
                var group = $filter('filter')($scope.personGroups, { id: group_id }, true)[0];
                if (group != null) positions = group.FK_positions_groups;
            }
            return positions;
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.save = function () {
            
            if ($scope.persons.to_date != null) $scope.persons.to_date.setHours(0, 0, 0, 0);
            if ($scope.persons.from_date != null) $scope.persons.from_date.setHours(0, 0, 0, 0);
            logService.debug($scope.persons)
            $uibModalInstance.close($scope.persons);
        }

}])

    ;